import React, { useEffect, useState } from "react";
import { useAudioHandlesContext } from "hooks/useAudioHandlesContext";
import { LineSC, SubtitleEditContainerSC, SubtitleWrapperSC } from "./styled";
import { getSubtitleRecommendsAction } from "providers/AudioProvider/actions";
import { IPhrasesWithSynonyms } from "types/subscribtios";
import { AudioTrack, ILang, MetadataToSubtitlesLanguages } from "providers/AudioProvider/types";
import { useAudioStateContext } from "hooks/useAudioStateContext";
import { EditBox } from "./components/EditBox";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { WordBank } from "./components/WordBank";
import { useWords } from "./hooks/useWords";
import { v4 as uuid } from "uuid";
import { Preloader } from "components/elements/Preloader";

export const ItemType = "WORD";
export interface TranslatedVariant {
  translated_sentence: { text: string; id: string; synonyms?: any }[];
  phrases_with_synonyms: IPhrasesWithSynonyms[];
}

interface SubtitleRecommendationProps {
  onMouseDown: () => void;
}

export function SubtitleRecommendation({ onMouseDown }: SubtitleRecommendationProps) {
  const handles = useAudioHandlesContext();
  const {
    folder,
    lang,
    editedRecommendationSubtitle: subtitleId,
    mediaId,
    originalLang,
  } = useAudioStateContext();
  const [recommendations, setRecommendations] = useState<TranslatedVariant[]>([]);
  const [currentTrack, setCurrentTrack] = useState<AudioTrack | null>(null);
  const [activeWordId, setActiveWordId] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const { updateWord, words, moveWord, addWord, reset, save, deleteWord, addWords } = useWords({
    setActiveWordId,
    subtitleId,
  });
  useEffect(() => {
    const getRecommendation = async () => {
      if (mediaId && folder && lang && subtitleId) {
        setLoading(true);
        const { data, error } = await getSubtitleRecommendsAction({
          mediaId,
          metasubtitle_id: subtitleId,
          folder_num: folder,
          lang: MetadataToSubtitlesLanguages[lang],
          variants: 3,
          synonyms: 4,
          language_from: MetadataToSubtitlesLanguages[originalLang],
        });
        setLoading(false);
        if (data?.variants) {
          const translatedSentence = data?.variants.map((variant) => {
            return {
              translated_sentence: variant.translated_sentence
                .split(" ")
                .map((word, i) => ({ text: word, id: uuid() })),
              phrases_with_synonyms: variant.phrases_with_synonyms,
            };
          });
          setRecommendations(translatedSentence);
          addWords(translatedSentence[0].translated_sentence);
        }
      }
    };
    void getRecommendation();
  }, [mediaId, folder, lang, subtitleId]);

  useEffect(() => {
    if (subtitleId && lang) {
      const track = handles.getElementById(subtitleId, lang as ILang);
      setCurrentTrack(track);
    }
  }, [subtitleId]);

  return (
    <DndProvider backend={HTML5Backend}>
      <SubtitleEditContainerSC>
        <LineSC onMouseDown={onMouseDown} />
        <SubtitleWrapperSC>
          <h5>Translation options (EN)</h5>
          <WordBank recommendations={recommendations} onWordClick={addWord} addWords={addWords} />
          <h5>✍️ Editable translation</h5>
          <EditBox
            words={words}
            activeWordId={activeWordId}
            setActiveWordId={setActiveWordId}
            updateWord={updateWord}
            moveWord={moveWord}
            reset={reset}
            addWord={addWord}
            save={save}
            deleteWord={deleteWord}
          />
        </SubtitleWrapperSC>
        {loading && <Preloader />}
      </SubtitleEditContainerSC>
    </DndProvider>
  );
}
